// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3NDrn","content":"RecentSearches_content__2Zh-1"};